export default __webpack_public_path__ + "static/media/group.c745186e.svg";